<template>
<v-container grid-list-md class="white--text text-center">

    <div class="issueCover-bg" :style='"background: url("+$props.cover+") no-repeat 50% 50%"'></div>

    <v-layout align-center justify-center>
        <v-flex xs10 mt-3 mb-3>
            <transition name="fade">
                <img :src="$props.cover" v-if="$props.cover" :alt="$props.title" class="issueCover-img block-center">
        </transition>
        </v-flex>
    </v-layout>

    <div class="issueCover-footer">

        <v-layout align-center justify-center>
            <v-flex xs8 mt-3 mb-3>
                <transition name="fade">
                    <h1 v-html="$props.title" class="display-2"></h1>
                </transition>
            </v-flex>
        </v-layout>

        <v-layout row wrap mt-4 class="issueCover-nav">
            <slot></slot>
        </v-layout>

    </div>

</v-container>
</template>

<script>
export default {
	name: 'issueCover',
	props: {
		title: '',
		cover: '',
	},
	data() {
		return {
		}
	},
}
</script>

<style lang="scss">
@import "../assets/css/_variables";

.issueCover {

    &-footer {
        @media (max-width: 599px) {
            h1 {
                font-size: 32px !important;
                line-height: 34px !important;
            }
        }
    }

    &-bg {
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        position: absolute;
        z-index: -1;
        background-size: cover !important;
        opacity: 0.10;
    }

    &-img {
        border-radius: 5px;
        max-height: 30vh;
        display: block;
        margin: 0 auto;
        transition: max-height 0.4s ease;
    }

    &-nav {
        .v-btn {
            font-size: 16px;
            height: auto;
            min-width: auto !important;

            .v-btn__content {
                font-weight: 400;
                padding: 6px 30px 8px 30px;
                display: block;
                line-height: 20px;
                border-radius: 5px;
            }

            .v-icon {
                width: 100%;
                display: block;
                margin-bottom: 10px;
            }
        }

        @media only screen and (max-width: 599px) {
            margin: 0 !important;

            .v-btn {
                width: 100%;

                .v-btn__content {
                    padding: 10px 0;
                }
            }
        }
    }
}
</style>
